<template>
	<layout>
		<div slot="masthead">
			<masthead :bgImage="bgImage" class="legal-masthead">
				<template slot="headline">{{ title }}</template>
			</masthead>
		</div>
		<div :class="['content', { extra: $mq.desktop }]" slot="body">
			<container :collapse="$mq.desktop">
				<slot />
			</container>
		</div>
		<template slot="footer">
			<FooterCTA />
		</template>
	</layout>
</template>

<script>

	import Layout from '@/layouts/layoutB'
	import Masthead from '@/layouts/layoutB/masthead'
	import FooterCTA from '@/components/FooterCTA'

	export default {
		components: { Layout, Masthead, FooterCTA },
		props: ['title'],
		data () {
			return {
				bgImage: require('img/blog-entry-bg2.jpg')
			}
		}
	}

</script>

<style lang="scss" scoped>

	.content {
		width:100%; color:#6D6E71; padding:5vw 0;
		&.extra {
			padding:8.7rem 11.2rem 0;
		}
	}

</style>



// WEBPACK FOOTER //
// src/layouts/legal/index.vue